import { useTranslation } from "react-i18next";

import DeleteButton from "../../../components/Buttons/DeleteButton";
import { useCanWrite } from "../../../utilities/helpers/roleUtilities";

type TruckLoadActionsProps = {
  disabled: boolean;
  onDelete: () => Promise<boolean>;
  onMove: () => void;
};

const TruckLoadActions: React.FC<TruckLoadActionsProps> = ({ disabled, onDelete, onMove }) => {
  const { t } = useTranslation("production");
  const canDelete = useCanWrite("Digging.DeleteTruckLoad");
  const canMove = useCanWrite("Digging.MoveLoadingRecord");

  if (!canDelete && !canMove) return null;

  return (
    <div className="flex justify-center align-items-center gap-1 w-full">
      {canDelete && <DeleteButton disabled={disabled} handleDelete={onDelete} />}
      {canMove && <button
        disabled={disabled}
        onClick={onMove}
        className="bg-theme-info hover:bg-theme-info-hover cursor-pointer disabled:cursor-not-allowed disabled:opacity-50 transition ease-in-out text-white font-bold py-2 px-4 whitespace-nowrap"
      >
        {t("trucksTable.move")}
      </button>}
    </div>
  );
};

export default TruckLoadActions;
